export default "<a target=\"_blank\" [href]=\"item.url\"><img [src]=\"item.image.url\"></a>\n"